/* eslint-disable react/no-array-index-key */

import { EditAgentsAvailability } from '../EditAgentsAvailability.container';

import { Box, Typography } from '@aircall/tractor-v2';
import { UserMinimalFragment } from '@generated/UserMinimalFragment';
import { useTranslation } from 'react-i18next';

export function ColumnFieldAvailability({
  ID,
  businessHours,
  isActive,
  isAvailable,
  state,
}: UserMinimalFragment) {
  const { t } = useTranslation();

  if (!isActive) {
    return (
      <Box py={14}>
        <Typography data-test={`user-card-extension-${ID}`} variant='bodyMediumS' color='grey.dark'>
          {t('app.pending_validation')}
        </Typography>
      </Box>
    );
  }

  return (
    <EditAgentsAvailability
      businessHours={businessHours}
      buttonAnimationDisabled
      id={ID}
      state={state}
      isAvailable={isAvailable}
    />
  );
}
